<dx-popup
    #creditApplicationBox
    width="60%"
    height="70%"
    [title]="popUpTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <dx-data-grid
                    width="100%"
                    height="100%"
                    [dataSource]="creditApplicationData"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    noDataText="No data to display"
                >
                    <dxi-column
                        *ngIf="isInternalUser"
                        caption="Action"
                        dataType="string"
                        alignment="center"
                        cellTemplate="actionTemplate"
                        headerCellTemplate="lockHeaderCellTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="source.title"
                        caption="Source"
                        dataType="string"
                        cellTemplate="sourceTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="target.title"
                        caption="Target"
                        dataType="string"
                        cellTemplate="targetTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="amount"
                        caption="Amount"
                        dataType="number"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="appliedDate"
                        caption="Applied Date"
                        dataType="date"
                        [format]="dateFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="updatedBy"
                        caption="Updated By"
                        dataType="string"
                        cellTemplate="userBioTemplate"
                    ></dxi-column>
                    <dxi-column dataField="subLedger" caption="Sub Ledger Title" dataType="string"></dxi-column>
                    <dxi-column
                        dataField="reversalDate"
                        caption="Reversal Date"
                        dataType="date"
                        [format]="dateFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="reversalDescription"
                        caption="Reversal Description"
                        dataType="string"
                    ></dxi-column>

                    <div *dxTemplate="let row of 'actionTemplate'">
                        <dx-button
                            type="default"
                            text="Unapply"
                            [width]="90"
                            (onClick)="onUnapplyClick(row.data)"
                        ></dx-button>
                    </div>

                    <div *dxTemplate="let row of 'sourceTemplate'">
                        <app-hyperlink-creator
                            mode="hyperlinkOnly"
                            [displayText]="row.value"
                            (onLinkClick)="onPaymentClick(row.data)"
                        ></app-hyperlink-creator>
                    </div>
                    <div *dxTemplate="let row of 'targetTemplate'">
                        <app-hyperlink-creator
                            mode="hyperlinkOnly"
                            [displayText]="row.value"
                            (onLinkClick)="onTargetClick(row.data)"
                        ></app-hyperlink-creator>
                    </div>

                    <div *dxTemplate="let row of 'userBioTemplate'">
                        <app-user-bio-link
                            [user]="row.data.updatedBy"
                            [communityId]="arPaymentParam?.communityId"
                        ></app-user-bio-link>
                    </div>

                    <div *dxTemplate="let header of 'lockHeaderCellTemplate'">
                        {{ header.column.caption }}
                        <app-security-info
                            securityIndicator="KEY"
                            apiAction="PUT"
                            apiUrl="api/cb/ar/creditapplication/unapply"
                        ></app-security-info>
                    </div>

                    <dxo-header-filter [visible]="false"></dxo-header-filter>
                    <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                    <dxo-group-panel [visible]="false"></dxo-group-panel>
                    <dxo-sorting mode="none"></dxo-sorting>
                    <dxo-scrolling mode="standard"></dxo-scrolling>
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#creditApplicationBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-ar-payment-details
    *ngIf="arPaymentDetailVisible"
    [visible]="arPaymentDetailVisible"
    [arPaymentParam]="arPaymentParams"
    (onARPaymentClose)="onARPaymentDetailClose($event)"
></app-ar-payment-details>

<app-ar-adjustment
    *ngIf="arAdjustmentDetailVisible"
    [visible]="arAdjustmentDetailVisible"
    [adjustmentDetailParam]="arAdjustmentDetailParam"
    (onAdjustmentDetailClose)="onARAdjustmentDetailClose($event)"
></app-ar-adjustment>

<app-ar-invoice-details
    *ngIf="arInvoiceDetailVisible"
    [visible]="arInvoiceDetailVisible"
    [invoiceDetailParam]="arInvoiceDetailParam"
    (onSuccess)="onARInvoiceActivitySuccess()"
    (onInvoiceDetailClose)="onARInvoiceDetailClose($event)"
></app-ar-invoice-details>

<cc-message-box #creditApplicationMessageBox></cc-message-box>
